import React from 'react';
import { Box, Typography, Button } from '@mui/material';
const EmailLinkHandler: React.FC = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3
      }}
    >
      <Typography variant="h4" gutterBottom>
        Connexion par email
      </Typography>
      <Typography variant="body1" gutterBottom align="center">
        Cette fonctionnalité n'est pas disponible dans la version publique.
      </Typography>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={() => window.location.href = 'https://app.tacticafoot.com/connexion'}
        sx={{ mt: 2 }}
      >
        Retour à la page de connexion
      </Button>
    </Box>
  );
};

export default EmailLinkHandler;
